export const technologyNav = () => {
  const nav = document.querySelector('.tech-nav');
  if (!nav) return;

  const links = Array.from(nav.querySelectorAll('.tech-nav__link[href^="#"]'));
  if (!links.length) return;

  const sections = links
    .map((link) => {
      const id = link.getAttribute('href')?.slice(1);
      if (!id) return null;

      const section = document.getElementById(id);
      if (!section) return null;

      return { id, link, section };
    })
    .filter(Boolean);

  if (!sections.length) return;
  let currentActiveId = null;

  const scrollToActiveLink = (link, { smooth = false } = {}) => {
    if (!link || nav.scrollWidth <= nav.clientWidth) return;

    const navRect = nav.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();

    const linkCenter =
      nav.scrollLeft + (linkRect.left - navRect.left) + linkRect.width / 2;

    const maxScroll = nav.scrollWidth - nav.clientWidth;
    const targetLeft = Math.min(
      maxScroll,
      Math.max(0, linkCenter - nav.clientWidth / 2)
    );

    nav.scrollTo({
      left: targetLeft,
      behavior: smooth ? 'smooth' : 'auto',
    });
  };

  const setActiveLink = (activeId, { smooth = false } = {}) => {
    if (!activeId || activeId === currentActiveId) return;
    currentActiveId = activeId;

    let activeLink = null;

    sections.forEach(({ id, link }) => {
      const isActive = id === activeId;
      link.classList.toggle('tech-nav__link--active', isActive);
      if (isActive) activeLink = link;
    });

    scrollToActiveLink(activeLink, { smooth });
  };

  const getOffset = () => {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const navHeight = nav.offsetHeight;
    return headerHeight + navHeight + 1;
  };

  const detectActiveSection = () => {
    const checkpoint = window.scrollY + getOffset();
    let activeId = sections[0].id;

    sections.forEach(({ id, section }) => {
      if (section.offsetTop <= checkpoint) {
        activeId = id;
      }
    });

    setActiveLink(activeId);
  };

  let rafId = null;
  const scheduleDetect = () => {
    if (rafId) return;
    rafId = window.requestAnimationFrame(() => {
      detectActiveSection();
      rafId = null;
    });
  };

  window.addEventListener('scroll', scheduleDetect, { passive: true });
  window.addEventListener('resize', () => {
    currentActiveId = null;
    scheduleDetect();
  });
  window.addEventListener('hashchange', () => {
    scheduleDetect();

    const hashId = window.location.hash.replace('#', '');
    if (!hashId) return;

    setActiveLink(hashId, { smooth: true });
  });

  detectActiveSection();
  // ensure nav is scrolled to the extreme left on initial load
  try {
    nav.scrollLeft = 0;
  } catch (e) {
    // noop
  }
};